<template>
  <div class="build-volk">
    <div class="wrapper">
      <img
        v-for="(filename, index) in images"
        :key="index"
        :src="require(`@/assets/images/build-volk/${filename}.svg`)"
        :class="filename"
        alt=""
        draggable="false"
      />
    </div>
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  name: 'BuildCity',
  data () {
    return {
      images: ['aletta', 'man-black', 'man-blue', 'man-red', 'pastor', 'stembus', 'woman-blue', 'woman-red']
    }
  },
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerElement: '#build-volk-trigger',
      triggerHook: 1,
      duration: '100%',
      offset: 200
    })

    const timeline = new TimelineMax()
      .fromTo('.woman-blue', 1, {
        x: -500,
        y: -500
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.aletta', 1, {
        x: 400,
        y: -600
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.woman-red', 1, {
        x: 300,
        y: -300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.man-red', 1, {
        x: -200,
        y: 200
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.pastor', 1, {
        x: -50,
        y: 500
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.man-blue', 1, {
        x: 100,
        y: 300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.man-black', 1, {
        x: 250,
        y: 400
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)
      .fromTo('.house-red', 1, {
        x: 400,
        y: -300
      }, { x: 0, y: 0, autoAlpha: 1 }, 0)

    this.$scrollmagic.addScene(scene.setTween(timeline))
  }
}
</script>

<style lang="scss" scoped>
.build-volk {
  position: relative;
  height: 307px;
  z-index: 1;
  margin-top: 50px;
  margin-bottom: 75px;

  @media (min-width: 768px) {
    margin-bottom: 100px;
  }
}

.wrapper {
  position: absolute;
  width: 375px;
  left: 50%;
  transform: translateX(-50%);

  > * {
    position: absolute;
    opacity: 0;
    z-index: 2;
  }
}

.stembus {
  left: 72px;
  top: 72px;
  opacity: 1;
  z-index: 1;
}

.woman-blue {
  left: 58px;
  top: 0;
}

.aletta {
  left: 259px;
  top: 0;
}

.woman-red {
  left: 343px;
  top: 52px;
}

.man-red {
  left: 19px;
  top: 158px;
}

.pastor {
  top: 191px;
  left: 98px;
}

.man-blue {
  left: 200px;
  top: 191px;
}

.man-black {
  left: 296px;
  top: 169px;
}
</style>
